module.exports = __webpack_public_path__ + "app-static/img/p_12.d3d09e4d.jpg";